import { locationDetailsSelector } from 'booking/selectors'
import { scanticketLocationSelector } from 'scanticket/selectors'

export const pagseguroMerchantIdSelector = createSelector(
    locationDetailsSelector,
    scanticketLocationSelector,
    (bookingLocationDetails, scanticketLocation) => bookingLocationDetails?.merchantId || scanticketLocation?.merchantID
)
